import React from 'react'

const IconClock = ({fillColor, style}) => {
  return (
   <svg xmlns="http://www.w3.org/2000/svg" className={'icon ' + fillColor} style={style} viewBox="0 -960 960 960">
      <path d="M592.64-200q-117.39 0-198.86-81.47-81.47-81.47-81.47-198.86 0-116.67 81.47-198.17Q475.25-760 592.64-760q116.67 0 198.17 81.5 81.5 81.5 81.5 198.17 0 117.39-81.5 198.86Q709.31-200 592.64-200Zm-.49-33.85q102.41 0 174.36-71.53 71.95-71.54 71.95-174.46 0-102.42-71.79-174.37-71.79-71.94-174.21-71.94-102.92 0-174.61 71.79-71.7 71.79-71.7 174.2 0 102.93 71.54 174.62 71.53 71.69 174.46 71.69Zm102.08-119.87 24.18-23.66-109.18-109.18v-141.13h-33.85v154.43l118.85 119.54ZM127.69-623.08v-33.84h144.62v33.84H127.69Zm-40 160v-33.84h184.62v33.84H87.69Zm40 160v-33.84h144.62v33.84H127.69ZM592.31-480Z"/>
   </svg>
  )
}
export default IconClock
